<template>
  <!-- Overlay covers the entire viewport -->
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
    @click="close"
  >
    <!-- Modal container; clicking here won’t trigger overlay close -->
    <div class="bg-white rounded shadow-lg relative p-6 w-full max-w-3xl" @click.stop>
      <!-- Close Button -->
      <button
        class="absolute top-2 right-2 text-gray-500 hover:text-[#B203BC] text-2xl font-bold"
        @click="close"
      >
        &times;
      </button>
      <!-- Content Slot -->
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseModal",
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
